import { t } from 'i18next';
import * as yup from 'yup';

import useProductValidationSchema from './ProductFormFields/useValidationSchema';

export default function useValidationSchema() {
  return yup.object().shape({
    products: yup
      .array()
      .label(t('CreateOrder:labels.products'))
      .of(useProductValidationSchema())
      .ensure()
      .min(1)
      .default([]),
  });
}
